import React from 'react';
import AuditLogs from '../AuditLogs';
import BackOfficeLayout from '../../components/backoffice/BackOfficeLayout';

export default function BackOfficeAuditLogs() {
  return <AuditLogs LayoutComponent={BackOfficeLayout} />;
}
